(() => {
  function initPth24d() {
    const root = document.querySelector('.pth24d-root');
    if (!root || root.dataset.pth24dInitialized === 'true') return;
    root.dataset.pth24dInitialized = 'true';

    const videoSection = root.querySelector('[data-pth24d-video-section]');
    if (videoSection) {
      const firefighter = root.querySelector('.pth24d-firefighter-proof') || root.querySelector('.pth253d-proof-profile');
      if (firefighter && videoSection.nextElementSibling !== firefighter) firefighter.before(videoSection);

      const videoIntro = videoSection.querySelector('.pth253d-section-intro > p:last-child');
      if (videoIntro) videoIntro.textContent = 'See how people use the PTH-24D in everyday home and RV environments.';
    }

    const mainImage = root.querySelector('.pth253d-gallery-image');
    const mediaButtons = [...root.querySelectorAll('[data-pth24d-media]')];
    const thumbTrack = root.querySelector('.pth253d-thumbnails');

    const sizedImageUrl = (source, width) => {
      if (!source) return '';
      const value = String(source);
      if (/([?&]width=)\d+/i.test(value)) {
        return value.replace(/([?&]width=)\d+/i, `$1${width}`);
      }
      return `${value}${value.includes('?') ? '&' : '?'}width=${width}`;
    };

    const fastImageUrl = (button) => sizedImageUrl(button.dataset.fullUrl, 900);
    const warmImage = (button) => {
      if (!button || button.dataset.pth24dImageWarmed === 'true') return;
      const source = fastImageUrl(button);
      if (!source) return;
      const image = new Image();
      image.decoding = 'async';
      image.src = source;
      button.dataset.pth24dImageWarmed = 'true';
    };

    const setActiveMedia = (button) => {
      mediaButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    };

    mediaButtons.forEach((button) => {
      button.addEventListener('pointerenter', () => warmImage(button), { once: true });
      button.addEventListener('focus', () => warmImage(button), { once: true });
      button.addEventListener('touchstart', () => warmImage(button), { once: true, passive: true });

      button.addEventListener('click', () => {
        if (!mainImage) return;

        setActiveMedia(button);
        const thumbnail = button.querySelector('img');
        const previewSource = thumbnail ? (thumbnail.currentSrc || thumbnail.src) : '';
        const targetSource = fastImageUrl(button) || button.dataset.fullUrl || mainImage.src;
        const requestKey = `${Date.now()}-${Math.random()}`;
        mainImage.dataset.pth24dRequestKey = requestKey;

        if (previewSource) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = previewSource;
        }

        if (button.dataset.imageWidth) mainImage.width = Number(button.dataset.imageWidth);
        if (button.dataset.imageHeight) mainImage.height = Number(button.dataset.imageHeight);
        mainImage.alt = button.dataset.alt || mainImage.alt;

        const nextImage = new Image();
        nextImage.decoding = 'async';
        nextImage.onload = () => {
          if (mainImage.dataset.pth24dRequestKey !== requestKey || !button.classList.contains('is-active')) return;
          mainImage.src = targetSource;
        };
        nextImage.src = targetSource;
      });
    });

    if (thumbTrack && mediaButtons.length > 5 && !root.querySelector('[data-pth24d-thumb-slider]')) {
      if (!document.getElementById('pth24d-gallery-slider-style')) {
        const style = document.createElement('style');
        style.id = 'pth24d-gallery-slider-style';
        style.textContent = `
          .pth24d-root .pth24d-thumb-slider{align-items:center;display:grid;gap:8px;grid-template-columns:28px minmax(0,1fr) 28px;margin-top:14px;width:100%}
          .pth24d-root .pth24d-thumb-viewport{-webkit-overflow-scrolling:touch;overflow-x:auto;overscroll-behavior-x:contain;scroll-behavior:smooth;scroll-snap-type:x proximity;scrollbar-width:none;touch-action:pan-x;width:100%}
          .pth24d-root .pth24d-thumb-viewport::-webkit-scrollbar{display:none}
          .pth24d-root .pth24d-thumb-slider .pth253d-thumbnails{display:flex;flex-wrap:nowrap;gap:8px;margin-top:0;min-width:0;width:100%}
          .pth24d-root .pth24d-thumb-slider .pth253d-thumbnail{aspect-ratio:1/1;flex:0 0 calc((100% - 32px)/5);min-height:0;overflow:hidden;padding:3px;scroll-snap-align:start;width:auto}
          .pth24d-root .pth24d-thumb-slider .pth253d-thumbnail img{height:100%;object-fit:contain;width:100%}
          .pth24d-root .pth24d-thumb-nav{align-items:center;background:transparent;border:0;color:#87929b;cursor:pointer;display:flex;font-size:28px;height:44px;justify-content:center;line-height:1;padding:0;width:28px}
          .pth24d-root .pth24d-thumb-nav:hover:not(:disabled){color:var(--pth24d-blue)}
          .pth24d-root .pth24d-thumb-nav:disabled{cursor:default;opacity:.25}
          @media screen and (max-width:640px){.pth24d-root .pth24d-thumb-slider{gap:4px;grid-template-columns:22px minmax(0,1fr) 22px}.pth24d-root .pth24d-thumb-slider .pth253d-thumbnails{gap:6px}.pth24d-root .pth24d-thumb-slider .pth253d-thumbnail{flex-basis:calc((100% - 24px)/5)}.pth24d-root .pth24d-thumb-nav{font-size:24px;height:38px;width:22px}}
        `;
        document.head.appendChild(style);
      }

      const slider = document.createElement('div');
      slider.className = 'pth24d-thumb-slider';
      slider.dataset.pth24dThumbSlider = 'true';

      const previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'pth24d-thumb-nav pth24d-thumb-nav--previous';
      previousButton.dataset.pth24dThumbPrev = 'true';
      previousButton.setAttribute('aria-label', 'Show previous product images');
      previousButton.innerHTML = '<span aria-hidden="true">&#8249;</span>';

      const viewport = document.createElement('div');
      viewport.className = 'pth24d-thumb-viewport';
      viewport.dataset.pth24dThumbViewport = 'true';
      viewport.setAttribute('tabindex', '0');
      viewport.setAttribute('aria-label', 'Product image thumbnails');

      const nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'pth24d-thumb-nav pth24d-thumb-nav--next';
      nextButton.dataset.pth24dThumbNext = 'true';
      nextButton.setAttribute('aria-label', 'Show next product images');
      nextButton.innerHTML = '<span aria-hidden="true">&#8250;</span>';

      thumbTrack.before(slider);
      viewport.appendChild(thumbTrack);
      slider.append(previousButton, viewport, nextButton);

      const updateThumbNav = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        previousButton.disabled = viewport.scrollLeft <= 2;
        nextButton.disabled = viewport.scrollLeft >= maxScroll - 2;
      };

      const scrollThumbs = (direction) => {
        const firstThumb = thumbTrack.querySelector('.pth253d-thumbnail');
        if (!firstThumb) return;
        const gap = Number.parseFloat(getComputedStyle(thumbTrack).gap) || 0;
        viewport.scrollBy({
          left: direction * (firstThumb.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      };

      previousButton.addEventListener('click', () => scrollThumbs(-1));
      nextButton.addEventListener('click', () => scrollThumbs(1));
      viewport.addEventListener('scroll', updateThumbNav, { passive: true });
      window.addEventListener('resize', updateThumbNav);

      mediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const viewportRect = viewport.getBoundingClientRect();
          const buttonRect = button.getBoundingClientRect();
          if (buttonRect.left < viewportRect.left || buttonRect.right > viewportRect.right) {
            const centeredLeft = button.offsetLeft - ((viewport.clientWidth - button.offsetWidth) / 2);
            viewport.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
          }
        });
      });

      requestAnimationFrame(updateThumbNav);
    }

    const quantityInput = root.querySelector('[data-pth24d-quantity-input]');
    const quantityButtons = [...root.querySelectorAll('[data-pth24d-quantity]')];
    const price = root.querySelector('[data-pth24d-price]');
    const unitPrice = Number(root.dataset.unitPrice || 0);
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
      } catch (_) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };
    quantityButtons.forEach((button) => button.addEventListener('click', () => {
      const quantity = Math.max(1, Number(button.dataset.pth24dQuantity || 1));
      if (quantityInput) quantityInput.value = String(quantity);
      quantityButtons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', String(selected));
      });
      if (price && unitPrice) price.textContent = money(unitPrice * quantity);
    }));

    const reviewCarousel = root.querySelector('[data-pth24d-highlight-carousel]');
    if (reviewCarousel) {
      const slides = [...reviewCarousel.querySelectorAll('[data-pth24d-highlight-slide]')];
      const dots = [...reviewCarousel.querySelectorAll('[data-pth24d-highlight-dot]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      const setActive = (index) => {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === activeIndex)));
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (reduceMotion || slides.length < 2) return;
        timer = window.setInterval(() => setActive(activeIndex + 1), 5000);
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => { setActive(i); start(); }));
      reviewCarousel.addEventListener('mouseenter', stop);
      reviewCarousel.addEventListener('mouseleave', start);
      reviewCarousel.addEventListener('focusin', stop);
      reviewCarousel.addEventListener('focusout', (event) => { if (!reviewCarousel.contains(event.relatedTarget)) start(); });
      setActive(activeIndex);
      start();
    }

    const viewport = root.querySelector('[data-pth24d-video-viewport]');
    const prev = root.querySelector('[data-pth24d-video-prev]');
    const next = root.querySelector('[data-pth24d-video-next]');
    if (viewport && prev && next) {
      const update = () => {
        const max = viewport.scrollWidth - viewport.clientWidth;
        prev.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = viewport.querySelector('.pth253d-video-card');
        if (!card) return;
        const carousel = viewport.querySelector('.pth253d-video-carousel');
        const gap = carousel ? Number.parseFloat(getComputedStyle(carousel).gap) || 0 : 0;
        const count = window.matchMedia('(max-width: 640px)').matches ? 1 : 2;
        viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * count, behavior: 'smooth' });
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    }

    root.querySelectorAll('[data-pth24d-video-player]').forEach((player) => {
      const video = player.querySelector('[data-pth24d-video-element]');
      const poster = player.querySelector('.pth253d-video-poster');
      const toggle = player.querySelector('[data-pth24d-video-toggle]');
      const source = player.dataset.videoSrc;
      if (!video || !toggle || !source) return;

      toggle.style.zIndex = '2';

      let loaded = false;
      const update = () => {
        const playing = loaded && !video.paused && !video.ended;
        player.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', playing ? 'Pause product video' : 'Play product video');
      };
      const loadVideo = () => {
        if (loaded) return;
        video.src = source;
        video.hidden = false;
        video.removeAttribute('hidden');
        video.controls = true;
        video.style.display = 'block';
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        if (poster) {
          poster.hidden = true;
          poster.style.display = 'none';
        }
        player.classList.add('is-loaded');
        video.load();
        loaded = true;
      };

      toggle.addEventListener('click', () => {
        loadVideo();
        if (video.paused || video.ended) {
          root.querySelectorAll('[data-pth24d-video-element]').forEach((other) => {
            if (other !== video && !other.paused) other.pause();
          });
          video.play().catch(update);
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPth24d, { once: true });
  else initPth24d();
})();
